<template>

  <div class="wrapper">

  <v-contactmodal></v-contactmodal>

  <v-sidebar activeNavItem="navLink1"></v-sidebar>

    <div class="main-panel">

      <v-navbar v-bind:title="'RFQ Detail'"></v-navbar>

      <div class="content" v-on:click="dissmissAutoCompletes()">
        <div class="row">
            <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">RFQ Details ({{ level }})</h4>
              </div>
              <div class="card-body">

                <div class="form row">

                  <div class="col-sm-8">
                    <div class="form-group">
                        <select class="form-control" id="statusselect" v-model="status" style="-webkit-appearance: none; -webkit-border-radius: 0px;">
                          <option>Open</option>
                          <option>Assigned</option>
                          <option>Customer Review</option>
                          <option>Sent for Review</option>
                          <option>Completed</option>
                          <option>Archived</option>
                        </select>
                    </div>
                  </div>

                  <div class="col-sm-4">
                      <button id="statusbutton" v-on:click="changeStatus()" class="btn btn-warning">Change Status</button>
                  </div>

                  <div class="col-sm-12">
                    <button v-on:click="getRFQPDF()" class="btn btn-success">Get PDF Summary</button>
                  </div>


                </div>
              </div> <!-- end card body -->

          </div>
          </div>
        </div>

        <h4><font color="red">{{ rfqErrorMessage }} </font></h4>


        <UploadDocument
          :showGenerate=true
          :documents="documents"
          :rfqId="rfqIdOnly"
          :rfq="rfq"
          @fileUploaded="saveDocumentToRFQ"
          @deleteUploadedDocument="deleteDocument"
        />

        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">RFQ Customer Details</h4>
                <small class="text-muted">{{ rfqIdOnly }}</small>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-sm-3 border-right">
                    <h5>Customer</h5>
                    <p><small class="text-muted">Company / Name</small><br>{{ cuscompany }}</p>
                    <p><small class="text-muted">Address</small><br>{{ cusaddress }}, {{cuscity}}, {{cusprovince}}<br>{{ cuspostal }}<br>{{cuscountry}}</p>
                    <p><small class="text-muted">Terms</small><br>{{ custerms }}</p>
                    <p><small class="text-muted">Due Date</small><br>{{ cusduedate }}</p>
                    <p><small class="text-muted">PO #</small><br>{{ cuspo }}</p>
                    <p><small class="text-muted">Sales #</small><br>{{ cussales }}</p>
                    <p><small class="text-muted">Transfer Order #</small><br>{{ custransferorder }}</p>
                  </div>
                  <div class="col-12 col-sm-3 border-right">
                    <h5>Shipper</h5>
                    <p><small class="text-muted">Company / Name</small><br>{{ shicompany }}</p>
                    <p><small class="text-muted">PO #</small><br>{{ shipo }}</p>
                    <p><small class="text-muted">Release #</small><br>{{ shirelease }}</p>
                    <p><small class="text-muted">Address</small><br>{{ shiaddress }}, {{ shicity }}, {{shiprovince}}<br>{{ shipostal }}<br>{{shicountry}}</p>

                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Appointment</small><br>{{ shiappointment }}</p></div>
                      <div class="col-6"><p><small class="text-muted">Liftgate</small><br>{{ shiliftgate }}</p></div>
                    </div>
                    <p><small class="text-muted">Pick Up Date</small><br>{{ shipickupdate }}</p>

                  </div>
                  <div class="col-12 col-sm-3 border-right">
                    <h5>Consignee</h5>
                    <p><small class="text-muted">Company / Name</small><br>{{ conname }}</p>
                    <p><small class="text-muted">PO #</small><br>{{ conpo }}</p>
                    <p><small class="text-muted">Address</small><br>{{ conaddress }}, {{ concity }}, {{ conprovince }}<br>{{ conpostal }}<br>{{ concountry }}</p>
                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Appointment</small><br>{{ conappointment }}</p></div>
                      <div class="col-6"><p><small class="text-muted">Liftgate</small><br>{{ conliftgate }}</p></div>
                    </div>
                    <p><small class="text-muted">Delivery</small><br>{{ condeliverydate }}</p>
                  </div>
                  <div class="col-12 col-sm-3">
                    <h5>Truck</h5>
                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Trailer Type</small><br>{{ trtrailertype }}</p></div>
                      <div class="col-6"><p><small class="text-muted">Suspension Type</small><br>{{ trsuspensiontype }}</p></div>
                    </div>
                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Temperature Control</small><br>{{ trtempcontrol }}</p></div>
                      <div class="col-6"><p><small class="text-muted">COD</small><br>{{ trcod }}</p></div>
                    </div>
                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Driver Assist</small><br>{{ trdriverassist }}</p></div>
                      <div class="col-6"><p><small class="text-muted">Mode</small><br>{{ trmode }}</p></div>
                    </div>
                    <div class="row">
                      <div class="col-6"><p><small class="text-muted">Service</small><br>{{ trservice }}</p></div>
                      <div class="col-6"><p><small class="text-muted">Dunnage Required</small><br>{{ trdunnagerequired }}</p></div>
                    </div>
                    <p><small class="text-muted">Special Instructions</small><br>{{ trspecialinstructions }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row" id="modifyrfqcard">



          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Assignee Quotes</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Due Date</th>
                          <th>From</th>
                          <th>To</th>
                          <th>Pickup</th>
                          <th>Delivery</th>
                          <th>Base Charge</th>
                          <th>Handling Charge</th>
                          <th>Border Charge</th>
                          <th>Fuel Charge</th>
                          <th>Additional Charge</th>
                          <th>Total Charge</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>

                        <template v-for="quoterow in quoterows">
                          <tr>
                            <td>{{ quoterow.customer }} </td>
                            <td>{{ quoterow.duedate }}</td>
                            <td>{{ quoterow.from }}</td>
                            <td>{{ quoterow.to }}</td>
                            <td>{{ quoterow.pickup }}</td>
                            <td>{{ quoterow.delivery }}</td>
                            <td>{{ quoterow.basecharge == "N/A" ? quoterow.basecharge : ("$" + quoterow.basecharge) }}</td>
                            <td>{{ quoterow.handlingcharge == "N/A" ? quoterow.handlingcharge : ("$" + quoterow.handlingcharge) }}</td>
                            <td>{{ quoterow.bordercharge == "N/A" ? quoterow.bordercharge : ("$" + quoterow.bordercharge)  }}</td>
                            <td>{{ quoterow.fuelcharge == "N/A" ? quoterow.fuelcharge : ("$" + quoterow.fuelcharge)  }}</td>
                            <td>{{ quoterow.additionalcharge == "N/A" ? quoterow.additionalcharge : ("$" + quoterow.additionalcharge)  }}</td>
                            <td>{{ quoterow.charge == "N/A" ? quoterow.charge : ("$" + quoterow.charge)  }}</td>
                            <td class="text-right">
                              <button :class="quoterow.messageclass" name="selectquotebutton" v-on:click="selectQuote(quoterow)" class="btn btn-sm btn-secondary">Select Quote</button>
                              <button :class="quoterow.messageclass2" name="finishquotebutton" v-on:click="finishQuote(quoterow)" class="btn btn-sm btn-secondary">Finish Quote</button>{{ quoterow.message }}
                              <button :class="quoterow.messageclassFinal" v-on:click="acceptQuote(quoterow)" class="btn btn-sm btn-success">Accept Quote</button>
                              <button :class="quoterow.messageclassFinal" v-on:click="rejectQuote($event, quoterow)" class="btn btn-sm btn-danger">Reject Quote</button>
                            </td>
                          </tr>
                        </template>




                      </tbody>
                    </table>




                    <div id="reworkQuoteDiv" style="display:none">
                      <p>You can either permanently close this RFQ.</p>
                      <button id="closeRFQButton" v-on:click="rejectRFQServer(false)" class="btn btn-danger">Close/Archive RFQ</button>

                      <br><br><p>Or you can rework it by selecting a different quote.</p>
                      <button id="reworkRFQButton" v-on:click="rejectRFQServer(true)" class="btn btn-secondary">Rework RFQ</button>
                    </div>

                    <div id="selectmarkupstyle"  style="display:none;width:40%">

                        <div class="form-group">
                          <div class="input-group">
                            <span class="input-group-addon">Markup</span>
                            <input type="text" placeholder="Enter % Markup Here" v-on:keyup="markupCalculator()" id="markup" name="markup" v-model="markup" class="form-control">
                            <span class="input-group-addon">%</span>
                          </div>
                        </div>

                        <div class="form-group">
                            <input type="text" placeholder="Optional notes or comments" id="markupnotes" name="markupnotes" v-model="markupnotes" class="form-control">
                        </div>

                        <div class="form-group">
                          <div class="input-group">
                              <div>Total Cost = $<b>{{ markupNewTotal }}</b></div>
                          </div>
                          <div style="padding-top:10px;left:36%;position:relative;">
                              <button v-on:click="cancelReloadPage()" class="btn btn-secondary">Cancel</button>&nbsp;
                              <button id="markupbutton" v-on:click="submitMarkup()" class="btn btn-success">Submit Markup</button>
                          </div>
                        </div>

                    </div>

                    <div>
                      <button id="addQuoteButton" v-on:click="addQuote()" class="btn btn-icon btn-xs btn-success quoteButton">Add Quote</button>
                    </div>

                    <div id="addquoteform"  style="display:none">

                      <div class="form-group">
                        <label for="quotefromlocation">From Location</label>
                        <input type="text" v-model="quotefromlocation" class="form-control" disabled>
                      </div>

                      <div class="form-group">
                        <label for="quotefromlocation">To Location</label>
                        <input type="text" v-model="quotetolocation" class="form-control" disabled>
                      </div>

                      <div class="form-group">
                        <label for="quoteshipickupdate">Pick Up</label>
                        <input type="text" class="form-control datetimepicker" v-model="quoteshipickupdate" ref="quoteshipickupdate" name="quote pick up" v-validate="'required|validDate'">
                      </div>

                      <div class="form-group">
                        <label for="quotedeliverydate">Delivery</label>
                        <input type="text" class="form-control datetimepicker" v-model="quotedeliverydate" ref="quotedeliverydate" name="quote delivery" v-validate="'required|validDate'">
                      </div>


                      <div class="form-group">
                        <label for="quotefromlocation">Transit Time</label>
                        <input type="text" v-model="quotetransittime" class="form-control">
                      </div>

                      <div class="form-group">
                        <label for="basecharge">Base Charge</label>
                        <input type="text" id="basecharge" name="basecharge" v-model="quotebasecharge" class="form-control">
                      </div>

                      <div class="form-group">
                        <label for="fuelcharge">Fuel Charge</label>
                        <input type="text" id="fuelcharge" name="fuelcharge" v-model="quotefuelcharge" class="form-control">
                      </div>

                      <div class="form-group">
                        <label for="bordercharge">Border Charge</label>
                        <input type="text" id="bordercharge" name="bordercharge" v-model="quotebordercharge" class="form-control">
                      </div>

                      <div class="form-group">
                        <label for="handlingcharge">Handling Charge</label>
                        <input type="text" id="handlingcharge" name="handlingcharge" v-model="quotehandlingcharge" class="form-control">
                      </div>

                      <div class="form-group">
                        <label for="bordercharge">Additional Charges</label>
                        <input type="text" id="additionalcharges" name="additionalcharges" v-model="quoteadditionalcharges" class="form-control">
                      </div>

                      <div class="form-group">
                        <label for="quotenotes">Quote Notes</label>
                        <input type="text" id="quotenotes" name="quotenotes" v-model="quotenotes" class="form-control">
                      </div>

                      <div class="form-group">
                        <label for="quotenumber">Quote Number</label>
                        <input type="text" id="quotenumber" name="quotenumber" v-model="quotenumber" class="form-control">
                      </div>

                      <div class="form-group">
                        <p v-for="error in errors.all()" class="help is-danger">{{ error }}</p>

                        <div class="input-group">
                            <button v-on:click="cancelReloadPage()" class="btn btn-secondary">Cancel</button>&nbsp;
                            <button id="submitquotebutton" v-on:click="beforeSubmitQuote" class="btn btn-success quoteButton">Submit Quote</button>
                        </div>
                      </div>
                    </div>




                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-12" id="addAssigneeSection">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">New Assignee</h4><br>

                <div class="row">
                  <div class="col-4">
                    <div class="form-group">
                      <input type="text" v-on:keyup="assigneeLiveSearch()" v-model="assigneename" class="form-control typeahead" autocomplete="off" placeholder="Name/Company" :disabled="submitingAssignee">
                      <div id="assigneeCustomLiveSearch" class="customLiveSearch" style="margin-top: -14px;">
                        <template v-for="(assigneerow, index) in assigneerows">
                          <div :key="index" class="customLiveSearchElement" v-on:click="assigneeSelected(assigneerow)">{{ assigneerow.email + " (" + assigneerow.name + ")" }}</div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <input type="text" class="form-control datetimepicker" v-model="assigneeduedate" placeholder="Due Date" :disabled="submitingAssignee">
                    </div>
                  </div>
                  <div class="col-4">
                    <button class="btn btn-icon btn-xs btn-success" v-on:click="assignRFQ()" :disabled="submitingAssignee">Send</button>
                  </div>
                </div>

              </div>
            </div>
          </div>


        </div> <!-- end editable assignee sections -->


        <div class="row">
          <div class="col">

            <div class="card">
              <div class="card-header">

              <div class="row">
                <div class="col-12">
                  <h4 class="card-title">Shipping Units</h4>
                </div>
              </div>

              </div>
              <div class="card-body">
                <div class="table-responsive">
                    
                    <table class="table table-borderless"> 
                        <thead>
                            <tr>
                                <th class="text-center squeeze"></th>
                                <th class="text-left" colspan="3" style="min-width: 320px; max-width: 320px;">Description / Lot</th>
                                <th class="text-center">Quantity</th>
                                <th class="text-center">Stackable</th>
                                <th class="text-center">Length {{suunitlength}}</th>
                                <th class="text-center">Width {{suunitlength}}</th>
                                <th class="text-center">Height {{suunitlength}}</th>
                                <th class="text-center">Weight {{suunitweight}}</th>
                                <th class="text-center">Hazard</th>
                                <th class="text-left" style="min-width: 120px; max-width: 120px;">Contents</th>
                                <th class="text-center squeeze"></th>
                            </tr>
                        </thead>
                        <tbody>
                        <template v-for="(row, shipIndex) in detailrows">
                          <TertiaryRow :key="'tertiary_'+shipIndex" :row="row" :shipIndex="shipIndex"
                          v-on:removeRow="null"
                          v-on:cloneRow="null"
                          :readOnly=true
                          />
                        </template>
                        </tbody>
                    </table>
                    
                </div>
              </div>
            </div>

          </div>
        </div>
        
        <ShippingSummary
          v-if="detailrows.length > 0"
          ref="summary"
          v-bind:rfq="rfq"
          v-bind:rows="detailrows"
          v-bind:density="density"
          v-bind:densityClass="densityclass"
          :totalWeight="totalWeight"
          :totalWeightKg="totalWeightKg"
        ></ShippingSummary>

        <div class="text-right">
          <a href="#/rfq/view" class="btn btn-success btn-wd"><i class="fa fa-chevron-left"></i> Back</a>
        </div>
      </div>

      <v-footer></v-footer>



    </div>
  </div>

</template>

<script>
import router from '../../router'
import apiService from '../../services/api.service'
import companyService from '../../services/company.service'
import Vue from 'vue'
import modal from 'vue-strap/src/Modal'
import config from '../../config'

import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'
import ContactModal from '../../components/ContactModal'
import TertiaryRow from '../../components/shippinglvls/TertiaryRow.vue';
import UploadDocument from '../../components/UploadDocument'
import ShippingSummary from "../../components/ShippingSummary";

import { validateDeliveryAfterPickup } from '../../utils/validation'
import {LB_TO_KG} from '../../constants/weightConversion'

var rfqErrorMessage = '';
var assigneename = ''
var assigneeduedate = ''


var status = ''
var level = ''
var cuscompany = ''
var cuspo = '';
var cussales = '';
var custransferorder = '';
var cusaddress = ''
var cuscity = ''
var cusprovince = ''
var cuscountry = ''
var cuspostal = ''
var custerms = ''
var cusentity = ''
var cusduedate = ''
var density = 'N/A'
var densityclass = 'N/A'
var totalWeight = 0;
var totalWeightKg = 0;
var shicompany = ''
var shipo = '';
var shirelease = '';
var shiaddress = ''
var shicity = ''
var shiprovince = ''
var shicountry = ''
var shipostal = ''
var shipickupdate = ''
var shiappointment = ''
var shiliftgate = ''
var conname = ''
var conpo = '';
var conaddress = ''
var concity = ''
var conprovince = ''
var concountry = ''
var conentity = ''
var conpostal = ''
var condeliverydate = ''
var conappointment = ''
var conliftgate = ''
var quotenumber = ''
var sudescription = ''
var sutype = ''
var suquantity = ''
var sulength = ''
var suwidth = ''
var suheight = ''
var suweight = ''
var sustackable = ''
var suunitsofmeasure = ''
var sucargodescription = ''
var sucargoquantity = ''
var suhazardous = ''
var suhsclassification = ''
var transittime = ''
var trtrailertype = ''
var trsuspensiontype = ''
var trtempcontrol = ''
var trliftgate = ''
var trdriverassist = ''
var trmode = ''
var trcod = ''
var trservice = ''
var trdunnagerequired = ''
var trspecialinstructions = ''
var markup = ''
var markupNewTotal = ''
var markedUpBaseCharge = ''
var markup2 = ''
var markup2value = ''

var markupnotes = '';
var quotenotes = '';

var quotefromlocation = ''
var quotetolocation = ''
var quoteshipickupdate = ''
var quotedeliverydate = ''
var quotetransittime = ''
var quotebasecharge = ''
var quotehandlingcharge = ''
var quotefuelcharge = ''
var quotebordercharge = ''
var quoteadditionalcharges = ''
var assigneerows = [ ]
var assignees = [ ]
var quoterows = [ ]
var detailrows = [ ]
var allCompanies = [ ]


export default {
  name: 'RFQDetail',

  components: {
    'modal': modal,
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer,
    'v-contactmodal': ContactModal,
    UploadDocument,
    TertiaryRow,
    ShippingSummary,
  },

  data: function () {
    return {
      rfq: null,
      rfqErrorMessage: rfqErrorMessage,

      rfqIdOnly: this.$route.params.id.split(".")[0],

      quotenotes: quotenotes,
      markupnotes: markupnotes,
      quotefromlocation: quotefromlocation,
      quotetolocation: quotetolocation,
      quoteshipickupdate: quoteshipickupdate,
      quotedeliverydate: quotedeliverydate,
      quotetransittime: quotetransittime,
      quotebasecharge: quotebasecharge,
      quotehandlingcharge: quotehandlingcharge,
      quotefuelcharge: quotefuelcharge,
      quotebordercharge: quotebordercharge,
      quoteadditionalcharges: quoteadditionalcharges,
      quotenumber: quotenumber,

      assigneename: assigneename,
      assigneeduedate: assigneeduedate,
      assigneerows: assigneerows,
      assignees: assignees,

      quoterows: quoterows,
      detailrows: detailrows,
      status: status,
      level: level,
      cuscompany: cuscompany,
      cuspo: cuspo,
      cusaddress: cusaddress,
      cuscity: cuscity,
      cusprovince: cusprovince,
      cuscountry: cuscountry,
      cuspostal: cuspostal,
      cusentity: cusentity,
      custerms: custerms,
      cusduedate: cusduedate,
      cussales: cussales,
      custransferorder: custransferorder,
      density: density,
      densityclass: densityclass,
      totalWeight: totalWeight,
      totalWeightKg: totalWeightKg,
      shicompany: shicompany,
      shipo: shipo,
      shirelease: shirelease,
      shiaddress: shiaddress,
      shicity: shicity,
      shiprovince: shiprovince,
      shicountry: shicountry,
      shipostal: shipostal,
      shiliftgate: shiliftgate,
      shipickupdate: shipickupdate,
      shiappointment: shiappointment,
      conname: conname,
      conpo: conpo,
      conaddress: conaddress,
      concity: concity,
      conprovince: conprovince,
      conpostal: conpostal,
      concountry: concountry,
      conentity: conentity,
      condeliverydate: condeliverydate,
      conappointment: conappointment,
      conliftgate: conliftgate,
      sudescription: sudescription,
      sutype: sutype,
      suquantity: suquantity,
      sulength: sulength,
      suwidth: suwidth,
      suheight: suheight,
      suweight: suweight,
      sustackable: sustackable,
      suunitsofmeasure: suunitsofmeasure,
      sucargodescription: sucargodescription,
      sucargoquantity: sucargoquantity,
      suhazardous: suhazardous,
      suhsclassification: suhsclassification,
      transittime: transittime,
      trtrailertype: trtrailertype,
      trsuspensiontype: trsuspensiontype,
      trtempcontrol: trtempcontrol,
      trcod: trcod,
      trdriverassist: trdriverassist,
      trmode: trmode,
      trservice: trservice,
      trdunnagerequired: trdunnagerequired,
      trspecialinstructions: trspecialinstructions,
      markup: markup,
      markupNewTotal: markupNewTotal,
      markedUpBaseCharge: markedUpBaseCharge,
      markup2: markup2,
      markup2value: markup2value,
      liveSearching: false,
      submitingAssignee: false,
      documents: [],
    }
  },
  mounted () {
    $(document).ready(function() {
      $('input').attr('autocomplete', 'new-password');
    });

    //always refresh after viewing this page to update the bold unread rows on the dashboard
    sessionStorage.refresh = "true";

    // callback from add contact modal component
    const vm = this
    vm.$on('populateContact', function (contactModal) {
      console.log("on populateContact");
      console.log("*** populateFromContactModal " + contactModal.modal_id + " " + contactModal.modal_name);
      var vAssigner = localStorage.getItem('local_id')
      localStorage.setItem('assignee_id', contactModal.modal_id)
      localStorage.setItem('assigner_id', vAssigner)
      this.assigneename = contactModal.modal_name
    })

    // Get the RFQ Details
    apiService.get('/kong/api/v1/rfq/id/', {
      headers: { 'X-Raefton-RFQ-ID': this.$route.params.id }
    }).then((response) => {
      var rel = response.data.Result
      vm.rfq = rel;
      vm.status = rel.status

      console.log(JSON.stringify(rel, null, 2))
      localStorage["lastViewedDate"+this.rfqIdOnly+localStorage.getItem('local_id')] = new Date().toISOString();

      vm.level = rel.securitylevel
      vm.cuscompany = rel.customer.name + ", " + rel.customer.company
      vm.cuspo = rel.customer.po
      vm.cussales = rel.customer.sales
      vm.custransferorder = rel.customer.transferOrder
      vm.cusentity = rel.customer.entity
      vm.cusaddress = rel.customer.address

      vm.cuscity = rel.customer.city
      vm.cusprovince = rel.customer.province
      vm.cuscountry = rel.customer.country

      vm.cuspostal = rel.customer.postal
      vm.quotetolocation = rel.consignee.postal
      sessionStorage.setItem('quotetolocation', rel.customer.postal)

      vm.custerms = rel.customer.terms
      vm.cusduedate = safeDate(rel.customer.duedate, rel.customer.dueDateTime);

      vm.shicompany = rel.shipper.name + ", " + rel.shipper.company
      vm.shipo = rel.shipper.po
      vm.shirelease = rel.shipper.release
      vm.assignees = rel.assignees
      vm.shiaddress = rel.shipper.address
      vm.shicity = rel.shipper.city
      vm.shiprovince = rel.shipper.province
      vm.shicountry = rel.shipper.country

      vm.shipostal = rel.shipper.postal

      vm.shiliftgate = rel.shipper.liftgate;
      if (vm.shiliftgate == null || vm.shiliftgate == "") vm.shiliftgate = rel.truck.liftgate;


      vm.quotefromlocation = rel.shipper.postal
      sessionStorage.setItem('quotefromlocation', rel.shipper.postal)

      vm.shipickupdate = safeDate(rel.shipper.pickupdate, rel.shipper.pickupDateTime);
      vm.quoteshipickupdate = vm.shipickupdate;
      console.log("----------" + vm.quoteshipickupdate);
      sessionStorage.setItem('quoteshipickupdate', vm.quoteshipickupdate)

      vm.shiappointment = rel.shipper.appointment == true ? "Yes" : "No"
      vm.conname = rel.consignee.name + ", " + rel.consignee.company
      vm.conpo = rel.consignee.po
      vm.conaddress = rel.consignee.address
      vm.concity = rel.consignee.city
      vm.conprovince = rel.consignee.province
      vm.concountry = rel.consignee.country
      vm.conentity = rel.consignee.entity
      vm.conpostal = rel.consignee.postal

      vm.condeliverydate = safeDate(rel.consignee.deliverydate, rel.consignee.deliveryDateTime);
      vm.quotedeliverydate = vm.condeliverydate;
      console.log("----------" + vm.quotedeliverydate);
      sessionStorage.setItem('quotedeliverydate', vm.quotedeliverydate)

      vm.conappointment = rel.consignee.appointment == true ? "Yes" : "No"

      vm.conliftgate = rel.consignee.liftgate;
      if (vm.conliftgate == null || vm.conliftgate == "") vm.conliftgate = rel.truck.liftgate;


      vm.density = rel.density
      vm.densityclass = rel.densityclass

      // Shipping Unit Stuff

      if (rel.shippingunit != null && rel.shippingunit.length > 0) {
        // Get a list of all current shipping units
        var rowslen = detailrows.length
        for (var m = 0; m < rowslen; m++) {
          detailrows.pop()
        }

        let totalWeight = 0;
        let totalWeightKg = 0;
        for (var q = 0; q < rel.shippingunit.length; q++) {
          const relSu = rel.shippingunit[q];
          // Push cargo
          var suCargo = []
          if (relSu.cargo != null && relSu.cargo.length > 0) {
            for (var w = 0; w < relSu.cargo.length; w++) {

              var quantity = relSu.cargo[w].quantity;
              if (quantity == null || quantity.length == 0) quantity = "N/A";
              suCargo.push({cargonumber: w + 1, cargodescription: relSu.cargo[w].cargo, cargoquantity: quantity, hazardousgoods: relSu.cargo[w].hazardousgoods, packinginstructions: relSu.cargo[w].packinginstructions, cargoclass: relSu.cargo[w].class, hsclassification: relSu.cargo[w].hsclassification, unnumber: relSu.cargo[w].unnumber})
            }
          }
          const itemWeight = relSu.weight;
          const itemQuantity = relSu.quantity;
          if(relSu.unitsofmeasure.includes('kgs')) {
            totalWeight += ((itemWeight / LB_TO_KG) * itemQuantity);
            totalWeightKg += (itemWeight * itemQuantity);
          } else if(relSu.unitsofmeasure.includes('lbs')) {
            totalWeight += (itemWeight * itemQuantity)
            totalWeightKg += ((itemWeight * LB_TO_KG) * itemQuantity)
          }
          detailrows.push({
            number: q + 1,
            description: relSu.description,
            type: relSu.type,
            quantity: relSu.quantity,
            length: relSu.length,
            width: relSu.width,
            height: relSu.height,
            weight: relSu.weight,
            stackable: relSu.stackable,
            unitsofmeasure: relSu.unitsofmeasure,
            cargorows: suCargo,
            components: relSu.components
          })
        }
        vm.totalWeight = Math.round(totalWeight*10)/10;
        vm.totalWeightKg = Math.round(totalWeightKg*10)/10;
      }
      vm.trtrailertype = rel.truck.trailertype
      vm.trsuspensiontype = rel.truck.suspensiontype
      vm.trtempcontrol = rel.truck.tempcontrol

      vm.trcod = rel.truck.cod;
      if (vm.trcod == null) vm.trcod = rel.consignee.cod;
      vm.trcod = vm.trcod == true ? "Yes" : "No"


      vm.trdriverassist = rel.truck.driverassist
      vm.trmode = rel.truck.mode
      vm.trservice = rel.truck.service
      vm.trdunnagerequired = rel.truck.dunnagerequired
      vm.trspecialinstructions = rel.truck.specialinstructions

      vm.documents = rel.documents;

      var rowlen = quoterows.length
      for (var j = 0; j < rowlen; j++) {
        quoterows.pop()
      }


      //for now don't allow the RFQ Creator, Main Customer, or Customer Company to add their own quote
      if (vm.level === 'Creator' || vm.level === 'Main Customer' || vm.level === 'Customer Company') {
        document.getElementById('addQuoteButton').style.display = 'none'
      }

      // assignees can only be added and changed under certain conditions
      vm.checkForReadOnly(vm, rel);

      console.log("---- I am " + localStorage.getItem('local_id'));

      // Load up the quotes row with this content
      if (rel.assignees !== null) {
        var isAQuoteSelected = false;
        for (var i = 0; i < rel.assignees.length; i++) {
        var rmessage = 'No Quote Yet'
        var rmessageclass = 'quotehide'
        var rmessage2class = 'quotehide'
        var rmessageclassFinal = 'quotehide'

            // Grab the name of the customer sending this data
            console.log('--- getting assignees details for ' + response.data.Result.assignees[i].assigneeid)
            apiService.get('/kong/api/v1/entity/id', {
              headers: {'X-Raefton-ID': response.data.Result.assignees[i].assigneeid}
            }).then(function (response) {
              var rer = response.data.Result
              for (var j = 0; j < rel.assignees.length; j++) {
                  if (rel.assignees[j].assigneeid === rer.parentid) {
                    console.log( rer.parentid + " " + JSON.stringify(rel.assignees[j], null, 2) );
                    console.log('localstorage');
                    
                    console.log(localStorage)
                    // add the name of this assingee
                    vm.assignees[j].name = rer.name


                    // calculate quote data
                    var quote = rel.assignees[j].quote

                    // add quote data row
                    if (quote !== null) {

                      console.log('-------QUOTE ' + rer.name + " " + rel.assignees[j].assigneeid + " " + quote.id + " " + quote.status)

                      // if I have sent a quote to a customer that is not myself then don't allow me to add or send more quotes.
                      if (rel.assignees[j].assigneeid === localStorage.getItem('local_id') && rel.assignees[j].assigneeid != rel.assignees[j].assignerid) {
                        if (quote.status === 'Sent' || quote.status === 'Awarded' || quote.status === 'Rejected') {
                          console.log("no modify because one of my quotes is Sent, Awarded or Rejected")
                          vm.setRFQReadOnly();
                        }
                      }

                      var quotecharge;
                      var rbasecharge = "N/A";
                      var rhandlingcharge = "N/A";
                      var rfuelcharge = "N/A";
                      var rbordercharge = "N/A";
                      var radditionalcharge = "N/A";
                      if (isNumeric(quote.finalmarkedupcost))
                      {
                        quotecharge = parseFloat(quote.finalmarkedupcost)
                      }
                      else if (isNumeric(quote.markedupcost))
                      {
                        quotecharge = parseFloat(quote.markedupcost)
                      }
                      else
                      {
                        var handlingcharge = 0
                        var fuelcharge = 0
                        var bordercharge = 0
                        var additionalcharge = 0
                        if (isNumeric(quote.fuelcharge)) {
                          fuelcharge = parseFloat(quote.fuelcharge)
                          rfuelcharge = parseFloat((fuelcharge * 100)/100).toFixed(2);
                        }
                        if (isNumeric(quote.bordercharge)) {
                          bordercharge = parseFloat(quote.bordercharge)
                          rbordercharge = parseFloat((bordercharge * 100)/100).toFixed(2);
                        }
                        if (isNumeric(quote.additionalcharge)) {
                          additionalcharge = parseFloat(quote.additionalcharge)
                          radditionalcharge = parseFloat((additionalcharge * 100)/100).toFixed(2);
                        }
                        if (isNumeric(quote.basecharge)) {
                          rbasecharge = parseFloat((quote.basecharge * 100)/100).toFixed(2);
                        }
                        if (isNumeric(quote.handlingCharge)) {
                          handlingcharge = parseFloat(quote.handlingCharge)
                          rhandlingcharge = parseFloat((quote.handlingCharge * 100)/100).toFixed(2);
                        }
                        quotecharge = parseFloat(quote.basecharge) + handlingcharge + fuelcharge + bordercharge + additionalcharge
                      }

                      var rcharge = parseFloat((quotecharge * 100)/100).toFixed(2);

                      rmessage = ''
                      rmessage2class = 'quotehide'
                      if (quote.status == "Selected") {

                        isAQuoteSelected = true;
                        //if I am the rfq owner or main customer, show the accept and reject buttons
                        // Same behavior for Customer Company for now
                        if (vm.level === 'Creator' || vm.level === 'Main Customer' || vm.level === 'Customer Company' || vm.level === 'Customer')
                        {
                          console.log(localStorage.getItem('local_id') + " I am the owner and get to accept or reject the whole RFQ");
                          rmessageclassFinal = '';
                          rmessageclass = 'quotehide'
                        }
                        else
                        {
                          //show that you have selected this quote and forwarded it up the chain
                          rmessage = "quote forwarded";
                          rmessageclassFinal = 'quotehide';
                          rmessageclass = 'quotehide'
                        }
                      }
                      else if (quote.status == "Rejected" || quote.status == "Awarded") {
                        rmessage = quote.status;
                        rmessageclass = 'quotehide'
                        rmessageclassFinal = 'quotehide';
                      }
                      else {
                        rmessageclassFinal = 'quotehide';
                        rmessageclass = ''
                      }

                      const assigneeDueDate = safeDate(rel.assignees[j].duedate, rel.assignees[j].dueDateTime);

                      const quoteRow = {
                        customer: rer.name,
                        fuelcharge: rfuelcharge,
                        bordercharge: rbordercharge,
                        additionalcharge: radditionalcharge,
                        assignee: rel.assignees[j].assigneeid,
                        assigner: rel.assignees[j].assignerid,
                        basecharge: rbasecharge,
                        handlingcharge: rhandlingcharge,
                        charge: rcharge,
                        id: quote.id,
                        message: rmessage,
                        messageclass: rmessageclass,
                        messageclass2: rmessage2class,
                        messageclassFinal: rmessageclassFinal,
                        duedate: assigneeDueDate,
                        from: quote.fromlocation,
                        to: quote.tolocation,
                        pickup: safeDate(quote.pickupdate, quote.pickupDateTime),
                        delivery: safeDate(quote.deliverydate, quote.deliveryDateTime),
                        quotenumber: quote.quotenumber
                      }
                      quoterows.push(quoteRow)
                    } else {
                      // Take them to the page allowing them to complete a quote
                      rmessage = ''
                      rmessage2class = ''
                      rmessageclass = 'quotehide'

                      // NOTE, ID is being used as the customer ID in this case
                      const assigneeDueDate = safeDate(rel.assignees[j].duedate, rel.assignees[j].dueDateTime);
                      quoterows.push({
                        customer: rer.name,
                        fuelcharge: "N/A",
                        bordercharge: "N/A",
                        additionalcharge: "N/A",
                        basecharge: "N/A",
                        handlingcharge: "N/A",
                        charge: "N/A",
                        id: rer.parentid,
                        message: rmessage,
                        messageclass: rmessageclass,
                        messageclass2: rmessage2class,
                        messageclassFinal: 'quotehide',
                        duedate: assigneeDueDate
                      })
                    }
                  }
              } // end for

              // disable any select buttons, we don't allow users to select more than one quote
              // they will have to reject and "rework it"
              setTimeout( function() {
                console.log(isAQuoteSelected + " isAQuoteSelected");
                if (isAQuoteSelected)
                {
                  var selectButtons = document.querySelectorAll("[name=selectquotebutton]");
                  for (var i = 0; selectButtons != null && i < selectButtons.length; i++) {
                    selectButtons[i].disabled = true;
                  }
                  selectButtons = document.querySelectorAll("[name=finishquotebutton]");
                  for (var i = 0; selectButtons != null && i < selectButtons.length; i++) {
                    selectButtons[i].disabled = true;
                  }
                }

                vm.checkForReadOnly(vm, rel);

              }, 500);


            }).catch(function (error) {
              console.log("Quote Display Error");
              console.log(error);
            })



        }
      }
      else
      {
        //show a friendly message if no quotes yet
        console.log("assignees null");
        // document.getElementById("existingQuotesTable").style.display = "none";
        // document.getElementById("noQuotes").style.display = "block";
      }




      // Successfully got a complete list, parse and add to the model
      // console.log(response)
    }).catch(function (error) {

      console.log(error);
      vm.rfqErrorMessage = error.response.data.Result

    })

    setTimeout(() => initDatePickers('.datetimepicker'), 500);

    // Get companies
    companyService.get().then(res => allCompanies = res) ;
  },
  methods: {


    checkForReadOnly(vm, rel) {
        // Check if status is open or assigned
        if (rel.status !== 'Open' && rel.status !== 'Assigned' && rel.status !== 'Customer Review') {
          vm.setRFQReadOnly();
        }

        //don't allow a Customer to edit anything about the RFQ
        if (vm.level === 'Customer') {
          vm.setRFQReadOnly();
        }

        document.getElementById('statusselect').selected = 'true'
        // Added same behavior for Customer Company for now
        if (vm.level !== 'Creator' && vm.level !== 'Main Customer' && vm.level !== 'Customer Company') {

          //don't allow editing during Customer Review by anyone except owner
          if (vm.status === 'Customer Review') {
            vm.setRFQReadOnly();
          }

          //document.getElementById('pdfmarkupbutton').style.display = 'none'
          document.getElementById('statusselect').disabled = true
          document.getElementById('statusbutton').disabled = true
        }
        else if (vm.status !== 'Completed') {
          //document.getElementById('pdfmarkupbutton').style.display = 'none'
        }
    },

    setRFQReadOnly() {
        console.log("this RFQ is read only");
        //document.getElementById('modifyrfqcard').style.display = 'none';
        document.getElementById('addAssigneeSection').style.display = 'none';
        document.getElementById('addQuoteButton').style.display = 'none';

        var selectButtons = document.querySelectorAll("[name=finishquotebutton]");
        for (var i = 0; selectButtons != null && i < selectButtons.length; i++) {
          $(selectButtons[i]).hide();
        }
    },

    cancelReloadPage: function() {
      window.location.reload();
    },

    dissmissAutoCompletes: function() {
      console.log("dissmissAutoCompletes");
      $(".customLiveSearch").hide();
    },

    showAutoComplete: function(id) {
      if(this.$store.getters.isContactModalOpen || !this.liveSearching) return;
      document.getElementById(id).style.display = 'block';
    },

    assigneeLiveSearch: function (event) {

      // Check if anything has been submitted
      if (this.assigneename.length < 3) {
        document.getElementById('assigneeCustomLiveSearch').style.display = 'none'
      } else {
        this.liveSearching = true;
        localStorage.removeItem('assignee_id');

        // Find Matches
        apiService.get('/entity/search/' + this.assigneename)
        .then(function (response) {

          // Pop everything off
          var len = assigneerows.length;
          for (var j = 0; j < len; j++) {
            assigneerows.pop()
          }

          assigneerows.push({email:"", name: "Add New", id: "-1"})
          var reslen = response.data.Result.length
          for (var i = 0; i < reslen; i++) {
            assigneerows.push({
            id: response.data.Result[i]._id,
            name: response.data.Result[i].name,
            email: response.data.Result[i].email,
            type: response.data.Result[i].type,
            address: response.data.Result[i].address,
            postal: response.data.Result[i].postal,
            city: response.data.Result[i].city,
            province: response.data.Result[i].province,
            country: response.data.Result[i].country,
            })
          }
        })
        .catch(function (error) {

          console.log('assignee auto complete error: ' + JSON.stringify(error))
          while(assigneerows.length > 0) { assigneerows.pop(); }
          assigneerows.push({email:"", name: "Add New", id: "-1"})

        }).finally(() => this.showAutoComplete("assigneeCustomLiveSearch"));
        // Sort it all
        assigneerows.sort()
      }
    },


    assigneeSelected: function (row) {
      this.liveSearching = false;
      this.dissmissAutoCompletes();

      console.log('selected: ' + JSON.stringify(row))
      if (row.id == "-1")
      {
        this.$modal.show('addCustomerModal')
      }
      else
      {
        var vAssigner = localStorage.getItem('local_id')
        assignee.assigneeCompanyId = (allCompanies.find(x => x.company === row.company)).id;
        localStorage.setItem('assignee_id', row.id)
        localStorage.setItem('assigner_id', vAssigner)
        this.assigneename = row.name
      }

    },


    assignRFQ: function (row) {
      var vm = this
      if (localStorage.getItem('assignee_id') == null || vm.assigneename == null || vm.assigneename.length == 0)
      {
        Vue.toasted.error('Please select an assignee.', { duration: 3500 })
      }
      else if (!vm.assigneeduedate || vm.assigneeduedate.length == 0)
      {
        Vue.toasted.error('Please enter a due date.', { duration: 3500 })
      }
      else
      {
        this.submitingAssignee = true;
        apiService.put('/kong/api/v1/rfq/assign', {
          rfqid: extractRFQId(this.$route.params.id),
          assigneeid: localStorage.getItem('assignee_id'),
          assignerid: localStorage.getItem('assigner_id'),
          dueDateTime: newSafeDate(vm.assigneeduedate)
        })
        .then(function (response) {
          // Successfully Assigned
          Vue.toasted.success('Successfully Assigned!', { duration: 3500 })

          if (vm.quoterows == null) vm.quoterows = [];
          vm.quoterows.push({
            customer: vm.assigneename,
            basecharge: "N/A",
            charge: "N/A",
            fuelcharge: "N/A",
            bordercharge: "N/A",
            handlingcharge: "N/A",
            additionalcharge: "N/A",
            id: localStorage.getItem('assignee_id'),
            message: "", messageclass: "quotehide",
            messageclass2: "",
            messageclassFinal: "quotehide",
            duedate: vm.assigneeduedate
          })
          localStorage.removeItem('assignee_id');
          vm.assigneename = "";
          vm.assigneeduedate = "";
        })
        .catch(function (error) {
          // show error
          console.log(error);
          Vue.toasted.error(error.response.data.Result, { duration: 3500 })
        })
        .finally(() => this.submitingAssignee = false);
      }
    },


    changeStatus: function (row) {
      // this.$refs.toast.showToast('Show me toast')
      var vm = this
      apiService.post('/rfq/update/' + extractRFQId(this.$route.params.id), {
        status: vm.status
      })
      .then(function (response) {
        Vue.toasted.success('Successfully Updated Status!', { duration: 3500 })
      })
      .catch(function (error) {
        const errorMessage = error.response.data.message? JSON.stringify(error.response.data.message) : JSON.stringify(error)
        Vue.toasted.error('Error changing status: ' + errorMessage, { duration: 5000 })
      })
    },

    submitMarkup: function () {
      var vm = this
      console.log("quote num: " + localStorage.getItem('local_quote_number') + " notes: " + vm.markupnotes);
      apiService.put('/kong/api/v1/rfq/select', {
        assignerid: localStorage.getItem('local_id'),
        customerid: vm.cusentity,
        rfqid: extractRFQId(this.$route.params.id),
        id: localStorage.getItem('local_quote_id'),
        newbase: vm.markedUpBaseCharge,
        markuppercent: vm.markup,
        cost: vm.markupNewTotal,
        markupnotes: vm.markupnotes,
        quotenumber: localStorage.getItem('local_quote_number'),
      }).then(function (response) {

        // Successfully submitted markup
        Vue.toasted.success('Successfully sent quote for review.', { duration: 3500 })
        // document.getElementById("markupbutton").style.display = "none";

        sessionStorage.refresh = "true";
        router.push('/rfq/view')

      }).catch(function (error) {
        Vue.toasted.error(error.response.data.Result, { duration: 3500 })
      })
    },



    acceptQuote: function(row) {
      // If you're the creator then update the RFQ with Awarded
      if (this.level === 'Creator' || this.level === 'Main Customer' || this.level === 'Customer Company') {
        var vm = this
        console.log("quote charge: " + row.charge + " " + row.quotenumber);
        apiService.put('/kong/api/v1/rfq/award', {
          assignerid: localStorage.getItem('local_id'),
          customerid: vm.cusentity,
          rfqid: extractRFQId(this.$route.params.id),
          id: row.id,
          cost: row.charge,
          quotenumber: row.quotenumber,
        }).then(function (response) {
          // Successfully awarded
          Vue.toasted.success('Successfully Awarded this Quote!', { duration: 3500 })

          sessionStorage.refresh = "true";
          router.push('/rfq/view')
        }).catch(function (error) {
          Vue.toasted.error(error.response.data.Result, { duration: 3500 })
        })

      }
      else
      {
        Vue.toasted.error("You are not the creator of this RFQ!", { duration: 3500 })
      }
    },

    rejectQuote: function(event, row) {

      // If you're the creator then update the RFQ with Rejected
      if (this.level === 'Creator' || this.level === 'Main Customer' || this.level === 'Customer Company') {
        console.log(event);
        event.target.style.display = "none";
        event.target.previousElementSibling.style.display = "none";
        document.getElementById("reworkQuoteDiv").style.display = "block";
        sessionStorage.setItem('reject_quote_id', row.id)
      }
      else {
        Vue.toasted.error("You are not the creator of this RFQ!", { duration: 3500 })
      }
    },


    rejectRFQServer: function(rework) {

      // If you're the creator then update the RFQ with Rejected
      if (this.level === 'Creator' || this.level === 'Main Customer' || this.level === 'Customer Company') {

        var vm = this
        apiService.put('/kong/api/v1/rfq/reject', {
          assignerid: localStorage.getItem('local_id'),
          customerid: vm.cusentity,
          rfqid: extractRFQId(this.$route.params.id),
          rework: rework,
          id: sessionStorage.getItem('reject_quote_id')
        }).then(function (response) {

          // Successfully rejected
          window.location.reload();

        }).catch(function (error) {

          if (error != null && error.response != null && error.response.data != null) {
            Vue.toasted.error(error.response.data, { duration: 3500 })
          }
          else {
            Vue.toasted.error('There was a problem reaching the server.', { duration: 3500 })
          }
        })
      }
      else
      {
        Vue.toasted.error("You are not the creator of this RFQ!", { duration: 3500 })
      }
    },


    selectQuote: function (row) {
      localStorage.setItem('local_charge', row.charge)
      localStorage.setItem('local_quote_id', row.id)
      localStorage.setItem('local_quote_number', row.quotenumber)

      // Initial value
      this.markupNewTotal = row.charge

      var selectButtons = document.querySelectorAll("[name=selectquotebutton]");
      for (var i = 0; selectButtons != null && i < selectButtons.length; i++) {
        selectButtons[i].disabled = true;
      }
      selectButtons = document.querySelectorAll("[name=finishquotebutton]");
      for (var i = 0; selectButtons != null && i < selectButtons.length; i++) {
        selectButtons[i].disabled = true;
      }


      document.getElementById('selectmarkupstyle').style.display = 'block'
      document.getElementById('addQuoteButton').style.display = 'none'

    },

    addQuote: function () {
      document.getElementById('addquoteform').style.display = 'block'
      document.getElementById('addQuoteButton').style.display = 'none'
    },
    markupCalculator: function (row) {
      var markupValue = isNaN(parseFloat(this.markup))? 0 : parseFloat(this.markup)

      var origCharge = parseFloat(localStorage.getItem('local_charge'));
      var newCharge = origCharge * (markupValue / 100);
      var newTotalCharge = origCharge + newCharge;

      this.markupNewTotal = parseFloat(Math.round(newTotalCharge * 100)/100).toFixed(2);
      console.log(this.markupNewTotal + " " + origCharge)
    },
    confirmSelectQuote: function (row) {
    },
    getRFQPDF: function () {
      apiService.get('/kong/api/v1/rfq/pdf', {
        headers: { 'X-Raefton-RFQ-ID': extractRFQId(this.$route.params.id) },
        responseType: 'arraybuffer'
      }).then(function (response) {
        var file = new Blob([response.data], {type: 'application/pdf'})
        var fileURL = URL.createObjectURL(file)
        var win = window.open(fileURL, '_blank')
        win.focus()
      }).catch(function (error) {
        Vue.toasted.error(error.response.data.Result, { duration: 3500 })
      })
    },
    releaseMarkupPDF: function () {
      document.getElementById('pdfmarkupbutton').style.display = 'none'
      document.getElementById('pdfmarkupcalc').style.display = 'block'
    },
    finishQuote: function (row) {
      router.push('/rfq/finish/' + extractRFQId(this.$route.params.id) + '/' + row.id)
    },
    beforeSubmitQuote: async function (event) {
      await this.$validator.validateAll();
      validateDeliveryAfterPickup(this.quoteshipickupdate, this.quotedeliverydate, 'quote delivery', this.$validator.errors);
      if(this.errors.count() === 0) this.submitQuote(event);
    },
    submitQuote: function (event) {

      console.log("submit quote " + this.quotenotes);

      // format amounts
      if (isNumeric(this.quotebasecharge)) {
        var f = parseFloat(this.quotebasecharge)
        this.quotebasecharge = parseFloat((f * 100)/100).toFixed(2) + "";
      }

      if (isNumeric(this.quotefuelcharge)) {
        var f = parseFloat(this.quotefuelcharge)
        this.quotefuelcharge = parseFloat((f * 100)/100).toFixed(2) + "";
      }

      if (isNumeric(this.quotebordercharge)) {
        var f = parseFloat(this.quotebordercharge)
        this.quotebordercharge = parseFloat((f * 100)/100).toFixed(2) + "";
      }

      if (isNumeric(this.quotehandlingcharge)) {
        var f = parseFloat(this.quotehandlingcharge)
        this.quotehandlingcharge = parseFloat((f * 100)/100).toFixed(2) + "";
      }

      if (isNumeric(this.quoteadditionalcharges)) {
        var f = parseFloat(this.quoteadditionalcharges)
        this.quoteadditionalcharges = parseFloat((f * 100)/100).toFixed(2) + "";
      }

      // Send API request
      apiService.put('/kong/api/v1/rfq/quote', {
        parentrfq: extractRFQId(this.$route.params.id),
        parentassigner: this.cusentity,
        fromlocation: this.quotefromlocation,
        tolocation: this.quotetolocation,
        pickupDateTime: newSafeDate(this.quoteshipickupdate),
        deliveryDateTime: newSafeDate(this.quotedeliverydate),
        transittime: this.quotetransittime,
        basecharge: this.quotebasecharge,
        fuelcharge: this.quotefuelcharge,
        bordercharge: this.quotebordercharge,
        handlingcharge: this.quotehandlingcharge,
        additionalcharge: this.quoteadditionalcharges,
        notes: this.quotenotes,
        quotenumber: this.quotenumber }, { headers: {'X-Raefton-RFQ-ID': extractRFQId(this.$route.params.id), 'X-Raefton-Contact-ID': this.$route.params.entity} })
      .then(function (response) {
        // If successful notify the user and segue to the RFQ view
        sessionStorage.refresh = "true";
        router.push('/rfq/view')
        Vue.toasted.success('Successfully Added Quote', { duration: 3500 })
      })
      .catch(function (error) {
        console.log(error);
        Vue.toasted.error("There was a problem submitting this quote.", { duration: 3500 })
      })
    },
    saveDocumentToRFQ: async function (fileData) {
      const response = await apiService.post(`/rfq/${this.rfqIdOnly}/document`, {fileData: fileData})
      this.documents = response.data;
    },
    deleteDocument: async function({rfqId, docId}) {
      if(!rfqId || !docId) return console.log('Unable to delete document. Missing Ids')
      const response = await apiService.delete(`/rfq/${rfqId}/document/${docId}`)
      this.documents = response.data;
    }


  }
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function extractRFQId(rfqDotEntity)
{
  return rfqDotEntity.split(".")[0];
}
</script>



// WEBPACK FOOTER //
// detail.vue?6e22d09b